import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ActionsService } from '../shared/models/helpers/actions-service';
import { MenuAction } from '../shared/models/menu-actions/menu-action';
import { MenuActionId } from '../shared/models/menu-actions/menu-action-id.enum';
import { ContactUsService } from './contact-us.service';

@Injectable()
export class HelpActionsService extends ActionsService {
  private readonly contactUsService = inject(ContactUsService);
  private readonly translocoService = inject(TranslocoService);

  actions: MenuAction<unknown>[] = [
    {
      id: MenuActionId.HELP_TUTORIALS,
      label: this.translocoService.translate('Guides et tutoriels'),
      icon: '@tui.square-play',
      execute: (): void => {
        window.open('https://www.pixacare.com/start', '_blank');
      },
    },
    {
      id: MenuActionId.HELP_CONTACT,
      label: this.translocoService.translate('Nous contacter'),
      icon: '@tui.mail',
      execute: (): void => {
        window.open('https://www.pixacare.com/support', '_blank');
      },
    },
    {
      id: MenuActionId.HELP_MANUAL,
      label: this.translocoService.translate('Manuel utilisateur'),
      icon: '@tui.file-text',
      execute: (): void => {
        window.open('https://cdn.pixacare.com/assets/IFU/IFU_Global.pdf', '_blank');
      },
    },
  ];
}
